import React, { Component } from "react";

import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";

import Actions from "./common/Actions";
import TabFilterPhotoStrip from "./filter/PhotoStrip";

import DeleteCategoryModal from "../modal/DeleteCategoryModal";

import Backend from "../../../utils/Backend";

const FIXED_CATEGORIES = [
  {
    id: "Favourites",
    type: "favourite",
    name: "FAVOURITES",
    noContentMessage: "Long press a filter to add to your favourites",
  },
  // {
  //   id: "MyEdits",
  //   type: "edit",
  //   name: "MY EDITS",
  //   noContentMessage: "Edited Filters show here"
  // },
  {
    id: "AllFiters",
    type: "global",
    name: "ALL FILTERS",
    noContentMessage: "Standard filters show here",
  },
];

export default class Filter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: props.filter,
      categories: [],
    };
    this.favouritesRef = React.createRef(null);
    this.editsRef = React.createRef(null);
    this.categoryFilters = React.createRef(null);
    this.categories = React.createRef(null);
    this.handleLongButtonPress = this.handleLongButtonPress.bind(this);
    this.handleLongButtonRelease = this.handleLongButtonRelease.bind(this);
  }

  componentDidMount() {
    this._loadCategories();
  }

  _loadCategories() {
    Backend.getCategories().then((categories) => {
      categories = categories.map((category) => {
        category.type = "in_category";
        return category;
      });
      this.setState({
        categories: [...FIXED_CATEGORIES, ...categories],
      });
    });
  }

  handleLongButtonPress(e, item) {
    e.preventDefault();
    this.longPressTimer = setTimeout(() => {
      if (item.type != "in_category") {
        return;
      }
      this.setState({ showDeleteCategoryModal: true, category: item });
    }, 1000);
  }

  handleLongButtonRelease() {
    clearTimeout(this.longPressTimer);
  }

  render() {
    let { filter } = this.props;
    return (
      <div className="filter">
        <Actions
          value={filter.data?.intensity || filter.intensity}
          min={0}
          max={1}
          step={0.01}
          showInputRange={filter?.type !== "Lightroom"}
          undoDisabled={this.props.undoDisabled}
          redoDisabled={this.props.redoDisabled}
          onUndoClicked={this.props.onUndoClicked}
          onRedoClicked={this.props.onRedoClicked}
          onValueChange={(value) => {
            let filterData = { ...filter };
            filterData.data.intensity = parseFloat(value);
            this.props.onFilterUpdated(filterData);
          }}
        />
        <Tab.Container defaultActiveKey={FIXED_CATEGORIES[1].id}>
          <div className="menu">
            <Nav variant="" className="flex-nowrap" justify>
              {this._renderCategories()}
            </Nav>
          </div>
          <Tab.Content className="filter-contents">
            {this._renderCategoryTabs()}
          </Tab.Content>
        </Tab.Container>
        <DeleteCategoryModal
          show={this.state.showDeleteCategoryModal}
          category={this.state.category}
          onHide={() =>
            this.setState({ showDeleteCategoryModal: false, category: null })
          }
          onCategoryDeleted={() => {
            this.setState({ showDeleteCategoryModal: false }, () => {
              this._loadCategories();
            });
          }}
        />
      </div>
    );
  }

  _renderCategories() {
    let { categories } = this.state;
    return categories.map((category) => this._renderCategory(category));
  }

  _renderCategoryTabs() {
    let { categories } = this.state;
    return categories.map((category) => this._renderFilters(category));
  }

  _renderCategory(category) {
    return (
      <Nav.Item
        key={category.id}
        onTouchStart={(e) => this.handleLongButtonPress(e, category)}
        onTouchEnd={this.handleLongButtonRelease}
        onMouseDown={(e) => this.handleLongButtonPress(e, category)}
        onMouseUp={this.handleLongButtonRelease}
        onMouseLeave={this.handleLongButtonRelease}
      >
        <Nav.Link eventKey={category.id}>
          <span>{category.name}</span>
        </Nav.Link>
      </Nav.Item>
    );
  }

  _renderFilters(category) {
    let noContentMessage =
      category.noContentMessage || category.name + " has no filters";
    return (
      <Tab.Pane key={category.id} eventKey={category.id} unmountOnExit>
        <TabFilterPhotoStrip
          key={category.id}
          type={category.type}
          categoryId={category.id}
          image={this.props.image}
          filter={this.props.filter}
          noContentMessage={noContentMessage}
          onSelected={(filter) => {
            this.props.onFilterUpdated(filter);
          }}
          onCategoriesUpdated={() => this._loadCategories()}
        />
      </Tab.Pane>
    );
  }
}
